export enum TIMER_STATES {
  INITIAL = "INITIAL",
  STARTED = "STARTED",
  PAUSED = "PAUSED",
  STOPPED = "STOPPED",
  RESETED = "RESETED",
}

export default TIMER_STATES;
